export default __webpack_public_path__ + "0ba17a90510be044151da5db98cbb47d.svg";